// 手机号，验证码，收货信息检验，不通过返回失败信息，通过返回空信息。

export const isMobile = (str: string) => {
  const mobilePattern =
    '^0*' +
    '(13|15|16|18|14|17|19)' +
    '(' +
    '\\d{9}|' +
    '\\d-\\d{3}-\\d{5}|' +
    '\\d-\\d{4}-\\d{4}|' +
    '\\d{2}-\\d{3}-\\d{4}|' +
    '\\d{2}-\\d{4}-\\d{3}' +
    ')$'; // 13800138000 // 138-001-38000 // 138-0013-8000 // 1380-013-8000 // 1380-0138-000
  const mobileRegExp = new RegExp(mobilePattern);
  if (!str) {
    return false;
  }
  return mobileRegExp.test(str);
};


export const validator = {
  mobile(m: string, area: string) {
    if (!m) return '请输入手机号码'
    if (area === '86' && !isMobile(m)) return '请输入正确的手机号'
    return ''
  },
  vcode(c: string) {
    return !c ? '请输入验证码' : ''
  },
  address(addressInfo: any) {
    const { name, address, province, city, area } = addressInfo
    const reg = new RegExp("[~'!@#￥$%^&*()-+_=:;/?,]")
    const regHtml = new RegExp('<[^>]+>');
    let errMsg = ''

    if (reg.test(name) || regHtml.test(name)) {
      errMsg = '收货人不能包含特殊字符'
    } else if (reg.test(address) || regHtml.test(address)) {
      errMsg = '详细地址不能包含特殊字符'
    } else if (name && name.length > 14) {
      errMsg = '收货人姓名最多填写14个字'
    } else if (address && address.length > 75) {
      errMsg = '详细地址最多填写75个字'
    } else {
      const hasIllegalAddress = ['香港', '澳门', '台湾'].filter(item => (province.indexOf(item) > -1 || city.indexOf(item) > -1));

      if (hasIllegalAddress.length > 0) {
        errMsg = '港澳台地区暂不支持物流配送'
      } else if (!province || !city || !area) {
        // 旧版客户端填写的港澳台地址只有province字段，并防止用户在其他入口填写收货地址时没有填市/区
        errMsg = '保存失败：请完善收货地址'
      }
    }

    return errMsg || false
  },
}
